<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="alert" :timeout="2000" color="error" top>
      <v-icon>mdi-alert</v-icon>
      &nbsp;&nbsp;您没有访问权限，系统将会跳转。
    </v-snackbar>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>时间槽模板</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                >新建</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-divider color="orange"></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.name"
                        label="模板名称"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model.number="counter"
                        label="时间槽个数"
                        append-icon="mdi-cog-outline"
                        @click:append="generate()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        prepend-icon="mdi-calendar-week"
                        v-model="editedItem.appliedDay"
                        label="常规日期"
                        :items="appliedDays"
                        item-text="Name"
                        item-value="Identity"
                        multiple
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="editedItem.appliedDate"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-combobox
                            v-model="editedItem.appliedDate"
                            multiple
                            chips
                            small-chips
                            label="特殊日期"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                          ></v-combobox>
                        </template>
                        <v-date-picker
                          v-model="editedItem.appliedDate"
                          multiple
                          no-title
                          scrollable
                          locale="zh-cn"
                        >
                          <v-btn text color="primary" @click="menu = false">
                            取消
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(editedItem.appliedDate)"
                          >
                            确定
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="pattern in editedItem.pattern"
                    :key="pattern.identity"
                  >
                    <v-col cols="12" sm="2" md="2">
                      <v-text-field
                        v-model="pattern.Name"
                        label="名称"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <v-text-field
                        v-model="pattern.StartTime"
                        label="开始时间 (HH:MM)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <v-text-field
                        v-model="pattern.EndTime"
                        label="结束时间 (HH:MM)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="close">取消</v-btn>
                <v-btn color="green darken-1" text @click="save">保存</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="copyItem(item)">
          mdi-content-copy
        </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
          :disabled="canDelete(item.assignedTemplate)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">重新加载</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment, { months } from "moment";
import { mapGetters } from "vuex";

export default {
  name: "eventSlotPattern",
  data: () => ({
    dialog: false,
    headers: [
      { text: "时间槽模板名称", value: "name" },

      { text: "时间槽模板时间槽数", value: "pattern.length" },
      { text: "绑定的预定模板个数", value: "assignedTemplate" },

      { text: "操作", value: "actions", sortable: false },
    ],
    appliedDays: [
      { Identity: "Monday", Name: "星期一" },
      { Identity: "Tuesday", Name: "星期二" },
      { Identity: "Wednesday", Name: "星期三" },
      { Identity: "Thursday", Name: "星期四" },
      { Identity: "Friday", Name: "星期五" },
      { Identity: "Saturday", Name: "星期六" },
      { Identity: "Sunday", Name: "星期日" },
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      identity: "",
      name: "",
      counter: 0,
      pattern: {},
    },
    defaultItem: {
      identity: "",
      name: "",
      counter: 0,
      pattern: {},
    },
    counter: 0,
    dates: [],
    isLoading: false,
    menu: false,
    alert: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新建时间槽" : "编辑时间槽";
    },
    ...mapGetters(["eventSlotPatterns", "userProfile"]),
  },

  async mounted() {
    this.initialize();
    /* this.isLoading = true;
      if (!this.eventSlotPatterns || this.eventSlotPatterns.length===0)
        await this.$store.dispatch('getEventSlotPattern');
      this.items = this.eventSlotPatterns.map(o=>{return {
        identity: o.Identity,
        name : o.Name,
        counter : o.pattern.length,
        appliedDay: o.appliedDay,
        appliedDate: o.appliedDate,
        pattern : o.pattern
      }})
      for (let i=0;i<this.items.length;i++)
      {
         for (let j=0;j<this.items[i].counter;j++)
         {
           this.items[i].pattern[j].StartTime = moment(this.items[i].pattern[j].StartTime).format('HH:mm:ss');
           this.items[i].pattern[j].EndTime = moment(this.items[i].pattern[j].EndTime).format('HH:mm:ss');
         }
      }
      this.isLoading = false;*/
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.items = [];
      this.isLoading = true;

      if (!this.userProfile) await this.$store.dispatch("getUserProfile");

      if (
        this.userProfile.UserGroups.filter((x) => x.Name === "Administrators")
          .length === 0
      ) {
        this.alert = true;
        setTimeout(() => this.$router.push("/"), 1000);
        return;
      }

      await this.$store.dispatch("getEventSlotPattern");
      if (this.eventSlotPatterns) {
        this.items = this.eventSlotPatterns.map((o) => {
          return {
            identity: o.Identity,
            name: o.Name,
            counter: o.pattern.length,
            appliedDay: o.appliedDay,
            appliedDate: o.appliedDate,
            assignedTemplate: o.assignedTemplate,
            pattern: o.pattern,
          };
        });
        for (let i = 0; i < this.items.length; i++) {
          for (let j = 0; j < this.items[i].counter; j++) {
            this.items[i].pattern[j].StartTime = moment(
              this.items[i].pattern[j].StartTime
            ).format("HH:mm");
            this.items[i].pattern[j].EndTime = moment(
              this.items[i].pattern[j].EndTime
            ).format("HH:mm");
          }
        }
      }
      this.isLoading = false;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.counter = this.editedItem.pattern.length;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("您确认要删除该项吗？") && this.del(item, index);
    },
    async del(item, index) {
      this.items.splice(index, 1);
      this.isLoading = true;
      await this.$store.dispatch("delEventSlotPattern", item.identity);
      this.isLoading = false;
    },
    canDelete(count) {
      return count > 0 ? true : false;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
        this.isLoading = true;
        if (!this.editedItem.pattern || this.editedItem.pattern.length > 0)
          this.editedItem.pattern.forEach((x) => {
            x.StartTime = this.convertTimeToDateTime(x.StartTime);
            x.EndTime = this.convertTimeToDateTime(x.EndTime);
            if (x.StartTime == "Invalid date" || x.EndTime == "Invalid date") {
              x.StartTime = "";
              x.EndTime = "";
              confirm("请检查您输入的时间格式");
              this.isLoading = false;
              return;
            }
          });
        else this.editedItem.pattern = [];
        await this.$store.dispatch("patchEventSlotPattern", this.editedItem);
        this.isLoading = false;
        this.editedItem = {};
        this.initialize();
      } else {
        this.items.push(this.editedItem);
        this.isLoading = true;
        if (!this.editedItem.pattern || this.editedItem.pattern.length > 0)
          this.editedItem.pattern.forEach((x) => {
            x.StartTime = this.convertTimeToDateTime(x.StartTime);
            x.EndTime = this.convertTimeToDateTime(x.EndTime);
          });
        else this.editedItem.pattern = [];
        await this.$store.dispatch("postEventSlotPattern", this.editedItem);
        this.isLoading = false;
        this.editedItem = {};
        this.initialize();
      }
      this.close();
    },
    async copyItem(item) {
      item.Identity = "";
      item.name += " Copy";
      this.items.push(item);
      this.isLoading = true;
      if (!item.pattern || item.pattern.length > 0)
        item.pattern.forEach((x) => {
          x.StartTime = this.convertTimeToDateTime(x.StartTime);
          x.EndTime = this.convertTimeToDateTime(x.EndTime);
        });
      else item.pattern = [];
      await this.$store.dispatch("postEventSlotPattern", item);
      this.isLoading = false;
      this.initialize();
    },
    convertTimeToDateTime(time) {
      try {
        var dateTime = moment(time, "HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
        return dateTime;
      } catch (e) {
        confirm("Invalid Dates");
      }
      // return moment().format('YYYY-MM-DD')+"T"+time+"+08:00";
    },

    generate() {
      let slotsPattern = [];
      for (let i = 0; i < this.counter; i++) {
        if (this.editedItem.pattern[i]) {
          // this.editedItem.pattern[i].StartTime = moment(this.editedItem.pattern[i].StartTime).add('hours', 8).format('HH:mm:ss');
          // this.editedItem.pattern[i].EndTime = moment(this.editedItem.pattern[i].EndTime).add('hours', 8).format('HH:mm:ss');

          slotsPattern.push(this.editedItem.pattern[i]);
        } else {
          slotsPattern.push({
            Name: `时段${i + 1}`,
            StartTime: "",
            EndTime: "",
          });
        }
      }
      this.editedItem.pattern = slotsPattern;
      this.editedItem.counter = this.counter;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/management/eventSlotPattern.vue